import React, { useState } from 'react'
import editIcon from '../../../../shared/assets/img/edit_icon.svg';
import { LabelValueCard } from '../../../../shared_elements';
import { Grid, Paper, Tooltip } from '@material-ui/core';
import { checkPermission } from '../../../../utils_v2';
export default function EngineRightCard ({engineRight, toggleEditSideBar}){ 
  const [showMore, setShowMore] = useState({});
  const toggleDescription = (id) => {
    setShowMore({
      ...showMore,
      [id]: !showMore[id],
    });
  };     
    return(
        <div className="vertical-card card-block">
          {checkPermission('contracts','engine_rights', 'U') ?<h5 className="para">
            <Tooltip title="Edit Engine Right" placement="top">
              <img style={{float:'right', cursor:'pointer'}} onClick = {toggleEditSideBar} width="16" className="editIcon" src={editIcon} alt="img"/>
            </Tooltip>
          </h5>:null}
            <Grid container spacing='3' style={{ width: 'auto' }} >
            <LabelValueCard md={4} label="Engine Title Swap Rights" value={engineRight?.titan_extra_fields?.engine_title_swap_rights || '--'} />
            <LabelValueCard md={4} label="Engine Pooling Rights" value={engineRight?.titan_extra_fields?.engine_pooling_rights || '--'} />
            <LabelValueCard md={4} label="Engine Swap Lessor Consent Required" value={engineRight?.titan_extra_fields?.engine_swap_lessor_consent || '--'} />
            <LabelValueCard md={12} label="Remarks" value={engineRight?.titan_extra_fields?.engine_right_remark && engineRight?.titan_extra_fields?.engine_right_remark?.length > 200 ? (
              <div>
                {showMore[engineRight?.id] && showMore[engineRight?.id] ? (
                  <span>
                    <span style={{wordBreak:'break-word'}} dangerouslySetInnerHTML={{ __html: engineRight?.titan_extra_fields?.engine_right_remark?.replace(/\n/g, '<br />') }} />
                    <a href='#' style={{ color: '#007bff', fontSize: '14px' }} onClick={(e) => { e.preventDefault(); toggleDescription(engineRight.id); }} >
                      less
                    </a>
                  </span>
                ) : (
                  <span>
                    <span style={{wordBreak:'break-word'}} dangerouslySetInnerHTML={{ __html: engineRight?.titan_extra_fields?.engine_right_remark.substring(0, 190)?.replace(/\n/g, '<br />') }} />
                    <a href='#' style={{ color: '#007bff', fontSize: '14px' }} onClick={(e) => { e.preventDefault(); toggleDescription(engineRight.id); }} >
                      ..more
                    </a>
                  </span>
                )}
              </div>
            ) : (
              <div>
                   {engineRight?.titan_extra_fields?.engine_right_remark ? <span style={{wordBreak:'break-word'}} dangerouslySetInnerHTML={{ __html: engineRight?.titan_extra_fields?.engine_right_remark.replace(/\n/g, '<br />') }} />:'--'}
              </div>
            )} />
            </Grid>
         </div>

     )
  }
